module.exports = __webpack_public_path__ + "static/media/bulle_discovery_FR_2.a4de67fe.png";